import { forEach, get, reduce, replace } from 'lodash';
import { runPipes } from './interpolation-pipes.helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Args = Record<string, any>;

export function interpolate(
  string: string,
  args: Args = {},
  complex?: boolean
): string {
  return complex
    ? complexInterpolate(string, args)
    : simpleInterpolate(string, args);
}

function simpleInterpolate(string: string, args: Args = {}): string {
  return reduce(
    args,
    (output: string, value: unknown, key: string) =>
      (output = replace(output, `{ ${key} }`, value as string)),
    string
  );
}

// EXAMPLE:
// string: "Financial year ended =({currentYear} - 1) = {blah} (preserve this part)"
// args: {currentYear: 2020, blah: 'test'}
// result: "Financial year ended 2019 = test (preserve this part)"
// notes: each variable will be replaced with value set in args, example: {variable}
// PIPES:
// string: "Financial year ended =({currentYearEnding | sub : {days: 1} : 'dd/MM/yyyy'})"
// args: {currentYearEnding: '2020-12-12T12:00:00Z'}
// result: "Financial year ended 11/12/2020"
// notes: pipes can be chained like in Angular
function complexInterpolate(string: string, args: Args = {}): string {
  // replace variables
  forEach(string.match(/\{(.*?)\}/g), (variable) => {
    const variableName: string = variable.match(/\{(.*?)\}/)?.[1] as string;

    string = replace(string, variable, get(args, variableName, variable));
  });

  // run expressions
  forEach(string.match(/=\((.*?)\)/g), (expression) => {
    const content: string = string.match(/=\((.*?)\)/)?.[1] as string;
    const [value, ...pipes]: string[] = content.split(' | ');

    string = replace(string, expression, runPipes(value, pipes));
  });

  return string;
}
